import {RestResource} from '../rest'

import { REVIEW_SERVER } from '../server'
import { athubAxios } from "../../util";

const reviewReport = new RestResource({server: REVIEW_SERVER, resource: 'reviewReport'});

reviewReport._getDetail = [reviewReport.server, reviewReport.resource, '{id}', 'detail'].join('/');
reviewReport.getDetail = function(id, athubConfig) {
  return athubAxios.get(reviewReport._getDetail.replace('{id}', id), athubConfig);
};

reviewReport._modifyDetail = [reviewReport.server, reviewReport.resource, '{id}', 'detail'].join('/');
reviewReport.modifyDetail = function(id, model, athubConfig) {
  return athubAxios.put(reviewReport._getDetail.replace('{id}', id), model, athubConfig);
};

reviewReport._workflowAuditUrl = [reviewReport.server, reviewReport.resource, 'workflow', 'audit'].join('/');
reviewReport.workflowAudit = function(params, athubConfig) {
  return athubAxios.postByMultipartForm(reviewReport._workflowAuditUrl, params, athubConfig);
};

reviewReport._downloadPdfUrl = [reviewReport.server, reviewReport.resource, 'workflow', 'audit'].join('/');
reviewReport.downloadPdf = function(id, defaultFilename, athubConfig) {
  return athubAxios.download([reviewReport.server, reviewReport.resource, id, 'pdf'].join('/'), defaultFilename, athubConfig);
};

export default reviewReport;
